import { c as _c } from "react/compiler-runtime";
import { DateTimePicker, Modal, PrimaryButton, getDate, toISOStringWithoutTimezone, transformDateToSeconds } from '@systemeio/ui';
import { BookingDetailsInterface } from 'modules/calendar/bookings/types/booking-details-interface';
import { BookingViewInterface } from 'modules/calendar/bookings/types/bookings-interface';
import { useTimeSlots } from 'modules/calendar/events/hooks/use-time-slots';
import { TimeSlot, TimeSlotsFilterInterface } from 'modules/calendar/events/types/calendar-filter-interface';
import { getDateOnly, getMonthStartEndDates } from 'modules/calendar/utils/date-time-formatters';
import { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { twMerge } from 'tailwind-merge';
import { EventTypeEnum } from '../../events/enums/event-type-enum';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
interface RescheduleBookingProps {
  booking: BookingViewInterface | BookingDetailsInterface;
  opened: boolean;
  onClose: () => void;
  onRescheduleBooking: (date: string, booking?: BookingViewInterface) => Promise<void>;
  isFetchingReschedule: boolean;
  bookingId: number;
  eventType?: EventTypeEnum;
}
export const RescheduleBookingModal = t0 => {
  const $ = _c(57);
  const {
    booking,
    onClose,
    opened,
    onRescheduleBooking,
    bookingId,
    eventType: t1,
    isFetchingReschedule
  } = t0;
  const eventType = t1 === undefined ? EventTypeEnum.Individual : t1;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const {
    revalidateModules
  } = useRevalidateModules();
  const [date, setDate] = useState(null);
  const t2 = booking.eventId;
  let t3;
  if ($[0] !== booking.date) {
    t3 = getMonthStartEndDates(getDate(booking.date));
    $[0] = booking.date;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== booking.eventId || $[3] !== t3) {
    t4 = {
      eventId: t2,
      dateRange: t3
    };
    $[2] = booking.eventId;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const [filter, setFilter] = useState(t4);
  let t5;
  if ($[5] !== bookingId || $[6] !== eventType || $[7] !== filter || $[8] !== opened) {
    t5 = {
      filter,
      eventType,
      bookingIdToBeRescheduled: bookingId,
      opened
    };
    $[5] = bookingId;
    $[6] = eventType;
    $[7] = filter;
    $[8] = opened;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    slots,
    isLoading
  } = useTimeSlots(t5);
  let t6;
  if ($[10] !== slots) {
    t6 = slots.map(_temp).filter(_temp2);
    $[10] = slots;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const dateSlots = t6;
  let t7;
  if ($[12] !== booking || $[13] !== date || $[14] !== onClose || $[15] !== onRescheduleBooking || $[16] !== revalidateModules) {
    t7 = async () => {
      if (!date) {
        return;
      }
      const bookingToPass = "id" in booking ? booking : undefined;
      await onRescheduleBooking(date, bookingToPass as BookingViewInterface | undefined);
      await revalidateModules([RequestModuleEnum.CalendarBookings], true);
      onClose();
    };
    $[12] = booking;
    $[13] = date;
    $[14] = onClose;
    $[15] = onRescheduleBooking;
    $[16] = revalidateModules;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const rescheduleBooking = t7;
  let t8;
  if ($[18] !== t) {
    t8 = t("dashboard.bookings.actions.reschedule_booking");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = booking.date;
  const t10 = isLoading && "after:block after:content-[\"\"] after:absolute after:left-0 after:right-0 after:top-0 after:bottom-0\n            before:w-12 before:h-12 before:border-4 before:border-brand-primary before:border-b-transparent before:rounded-full\n            before:absolute before:top-[35%] before:left-[40%] before:animate-spin";
  let t11;
  if ($[20] !== t10) {
    t11 = twMerge("relative", t10);
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = date_1 => {
      setFilter(prev => ({
        ...prev,
        dateRange: getMonthStartEndDates(date_1)
      }));
    };
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== dateSlots || $[24] !== slots) {
    t13 = date_2 => filterTime(date_2, slots, dateSlots);
    $[23] = dateSlots;
    $[24] = slots;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== dateSlots) {
    t14 = date_3 => {
      const dateOnly = getDateOnly(toISOStringWithoutTimezone(date_3));
      return dateOnly ? dateSlots.includes(dateOnly) : false;
    };
    $[26] = dateSlots;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t14) {
    t15 = {
      timeIntervals: 1,
      calendarClassName: t11,
      timeClassName: _temp3,
      onMonthChange: t12,
      filterTime: t13,
      filterDate: t14
    };
    $[28] = t11;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = val => {
      if (val) {
        setDate(val);
      }
    };
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const t17 = user?.createdAt;
  const t18 = user?.timezone;
  const t19 = user?.dateFormat;
  const t20 = user?.timeFormat;
  let t21;
  if ($[33] !== booking.date || $[34] !== intlLocale || $[35] !== t15 || $[36] !== t17 || $[37] !== t18 || $[38] !== t19 || $[39] !== t20) {
    t21 = <DateTimePicker value={t9} customProps={t15} onChange={t16} createdAt={t17} timezone={t18} userDateFormat={t19} userTimeFormat={t20} intlLocale={intlLocale} />;
    $[33] = booking.date;
    $[34] = intlLocale;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== rescheduleBooking) {
    t22 = () => rescheduleBooking();
    $[41] = rescheduleBooking;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t) {
    t23 = t("dashboard.bookings.actions.reschedule_booking");
    $[43] = t;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== isFetchingReschedule || $[46] !== t22 || $[47] !== t23) {
    t24 = <div className="flex justify-center"><PrimaryButton onClick={t22} isFetching={isFetchingReschedule}>{t23}</PrimaryButton></div>;
    $[45] = isFetchingReschedule;
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t21 || $[50] !== t24) {
    t25 = <div className="flex flex-col gap-3">{t21}{t24}</div>;
    $[49] = t21;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== onClose || $[53] !== opened || $[54] !== t25 || $[55] !== t8) {
    t26 = <Modal opened={opened} title={t8} onClose={onClose}>{t25}</Modal>;
    $[52] = onClose;
    $[53] = opened;
    $[54] = t25;
    $[55] = t8;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  return t26;
};
function filterTime(dateAndTime: Date, slots: TimeSlot[], dateSlots: string[]) {
  const date = getDateOnly(toISOStringWithoutTimezone(dateAndTime));
  const time = transformDateToSeconds(dateAndTime);
  const timeSlots = slots.find(slot => getDateOnly(slot.date) === date)?.spots || [];
  return date !== null && dateSlots.includes(date) && timeSlots.some(({
    startTime
  }) => startTime === time);
}
function _temp(x) {
  return getDateOnly(x.date);
}
function _temp2(date_0) {
  return date_0 !== null;
}
function _temp3() {
  return "aria-disabled:hidden";
}